import React from "react";

const AVANTAGES = [
  {
    num: "01",
    title: "Réduction sur le prochain atelier",
    desc: "Pendant le mois qui suit ta session, −10 % sur ta prochaine réservation d'atelier, sortie thématique ou parcours Lyon.",
  },
  {
    num: "02",
    title: "Accompagnement personnalisé",
    desc: "Pendant ce même mois, un suivi individuel sur tout ce qui est proposé : conseils personnalisés, défis, axes d'amélioration ciblés.",
  },
];

function PremiumAvantages() {
  return (
    <section className="premium-avantages" aria-label="Avantages du tarif Premium">
      <div className="premium-avantages__container">
        <div className="premium-avantages__left">
          <span className="premium-avantages__eyebrow">Premium</span>
          <h2 className="premium-avantages__title">
            Plus qu'un tarif —<br />une communauté.
          </h2>
          <p className="premium-avantages__sub">
            Choisir le premium, c'est profiter d'un mois d'avantages après
            chaque sortie ou atelier : accompagnement personnalisé et
            réduction sur ta prochaine réservation. Le serveur Discord de la
            communauté et l'accès prioritaire aux nouvelles dates, eux, sont
            ouverts à tous les participants — standard comme premium.
          </p>
        </div>
        <ul className="premium-avantages__list" aria-label="Liste des avantages premium">
          {AVANTAGES.map((a) => (
            <li key={a.num} className="premium-avantage">
              <span className="premium-avantage__num" aria-hidden="true">
                {a.num}
              </span>
              <div>
                <h3 className="premium-avantage__title">{a.title}</h3>
                <p className="premium-avantage__desc">{a.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default PremiumAvantages;
